export default function genererCritereRechercheTypeOt() {
  return {
    auto: null,
    typesIds: [],
    types: [],
    actionsInterventionsOt: [],
    produits: [],
  };
}
